import { render } from "./LoadingBar.vue?vue&type=template&id=09c08f0b&ts=true"
import script from "./LoadingBar.vue?vue&type=script&lang=ts"
export * from "./LoadingBar.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__